import moment from 'moment'
import React, { useState } from 'react'
import { useSelector } from 'react-redux'
import { AiOutlineDown } from 'react-icons/ai'
import { DatePicker, Dropdown, Menu } from 'antd'
import { Switch, Route, Link } from 'react-router-dom'

import { stringifyDate, useListData, presets } from '../../modules'

import Receive from "../../components/reusable/receive"
import StockTake from '../../components/drawers/stockTake'
import NewStockTake from '../../components/drawers/newStockTake'

const { RangePicker } = DatePicker

const StockTakes = ({ store }) => {
    const { user } = useSelector(state => state.application)

    const [sString, setSString] = useState('')
    const [ranges, setRanges] = useState()
    
    const [
        { loading, error, fetch },
        { list },
        { navigate, Paginate, page = 1, limit = 10 }
    ] = useListData('stockTakes', ranges ? {
        store: store?.value,
        string: sString,
        from: ranges[0]?._d ?? null, 
        to: ranges[1]?._d ?? null
    } : {
        store: store?.value,
        string: sString
    }, { notify: true })

    const refresh = resetNav => {
        if (resetNav)
            navigate(1)

        fetch()
    }

    const selectRange = range => {
        setRanges(range)
        refresh()
    }

    const searchSent = str => {
        setSString(str)
        if (str?.trim()?.length > 2 || !str) {
            setSString(str)
            refresh(true)
        }
    }

    return (
        <div className="px-4 sm:px-6 lg:px-8 py-8 w-full max-w-9xl mx-auto">
            <div className="sm:flex sm:justify-between sm:items-center mb-2">
                <ul className="flex flex-wrap justify-center sm:justify-start mb-8 sm:mb-0 -space-x-3 -ml-px" />
                <div className="flex items-center justify-between w-full">
                    <input
                        onChange={e => searchSent(e.target.value)}
                        value={ sString }
                        className="mb-3 appearance-none block max-w-4xl bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight focus:outline-none focus:bg-white"
                        id="grid-ssearch"
                        type="text"
                        placeholder="02648" />
                    <span className="flex">
                        {/* <Select
                            value={classif}
                            className="mr-2"
                            onChange={ changeClassif }
                            styles={{ input: styles => ({ ...styles, minWidth: '10em' }) }}
                            options={ ['All', 'Pending', 'Seen'].map(cls => ({ label: cls, value: cls })) }
                            placeholder="Viewed Status" /> */}
                        <RangePicker value={ ranges } onChange={ selectRange } ranges={ presets } />
                    </span>
                </div>
            </div>
            <div className="col-span-full xl:col-span-8 bg-white shadow-lg rounded-sm border border-gray-200">
                <header className="px-5 py-4 border-b border-gray-100 flex justify-between items-center">
                    <h2 className="font-semibold text-gray-800">Stock Takes</h2>
                    {
                        (store?.permissions?.includes('*') || store?.permissions?.includes('handle-requests') || user?.issuperuser) &&
                        <Dropdown
                            overlay={
                                <Menu>
                                    <Menu.Item>Download Stock Take Sheet</Menu.Item>
                                    <Link to="/app/store/stock-take/new"><Menu.Item >Upload Stock Take Sheet</Menu.Item></Link>
                                </Menu>
                            }>
                            <button className="btn hisani-btn-green-light text-white">
                                <span className="hidden xs:block mr-2">Actions</span>
                                <AiOutlineDown />
                            </button>
                        </Dropdown>
                    }
                </header>
                <div className="p-3">
                    <div className="overflow-x-auto">
                        <Receive
                            error={error}
                            loading={loading}
                            progress>
                            {
                                list.length > 0 ?   
                                    <table className="table-auto w-full">
                                        {/* Table header */}
                                        <thead className="text-xs uppercase text-gray-400 bg-gray-50 rounded-sm">
                                            <tr>
                                                <th className="p-2">
                                                    <div className="font-semibold text-center">No</div>
                                                </th>
                                                <th className="p-2">
                                                    <div className="font-semibold text-left">Code</div>
                                                </th>
                                                <th className="p-2">
                                                    <div className="font-semibold text-left">Uploaded By</div>
                                                </th>
                                                <th className="p-2">
                                                    <div className="font-semibold text-left">Status</div>
                                                </th>
                                                <th className="p-2">
                                                    <div className="font-semibold text-left">Date</div>
                                                </th>
                                                <th className="p-2">
                                                    <div className="font-semibold text-center"></div>
                                                </th>
                                            </tr>
                                        </thead>
                                        {/* Table body */}
                                        <tbody className="text-sm font-medium divide-y divide-gray-100">
                                            {
                                                list.map((st, key) =>
                                                    <tr>
                                                        <td className="p-2">
                                                            <div className="text-center">{((page - 1) * limit) + key + 1}.</div>
                                                        </td>
                                                        <td className="p-2">
                                                            <div className="">#{ Number(st?.code) < 1000 ? ('00000' + st?.code).slice(-4) : st?.code }</div>
                                                            <p className="text-gray-500 text-xs italic mb-0">From { stringifyDate(st.startedOn) }</p>
                                                            <p className="text-gray-500 text-xs italic">To { stringifyDate(st.completedOn) }</p>
                                                        </td>
                                                        <td className="p-2">
                                                            <div className="">{ st?.uploadedBy?.name }</div>
                                                            <p className="text-gray-500 text-xs italic">Uploaded On { stringifyDate(st.uploadedOn) }</p>
                                                        </td>
                                                        <td className="p-2">
                                                            <div className={ st?.processCompletedOn ? 'text-green-500' : 'text-yellow-500' }>{  st?.processCompletedOn ? "Completed" : 'Pending'  }</div>
                                                            { st?.processCompletedOn && <p className="text-gray-500 text-xs italic">On { stringifyDate(st.processCompletedOn) }</p> }
                                                        </td>
                                                        <td className="p-2">
                                                            <div className="text-center">{ stringifyDate(st.date) }</div>
                                                        </td>
                                                        <td className="p-2 text-center">
                                                            <Link to={ `/app/store/stock-take/${st._id}` }>
                                                                <button className="hisani-btn-green-light text-white font-medium ml-2 rounded-lg text-sm px-3 py-1.5 text-center">View</button>
                                                            </Link>
                                                        </td>
                                                    </tr>
                                                )
                                            }
                                        </tbody>
                                    </table>
                                :
                                    <div className="flex items-center justify-center h-28">
                                        <h2>No requests { sString?.trim()?.length > 2 ? `by "${sString}"` : '' } have been sent to { store?.name }</h2>
                                    </div>
                            }
                        </Receive>
                        { Paginate }
                    </div>
                </div>
            </div>
            <Switch>
                <Route exact path="/app/store/stock-take/new">
                    <NewStockTake path="/app/store/stock-take" store={ store } onPerform={ refresh } />
                </Route>
                <Route exact path="/app/store/stock-take/:id">
                    <StockTake path="/app/store/stock-take" store={ store } onPerform={ refresh } />
                </Route>
            </Switch>
        </div>        
    )

}

export default StockTakes